
/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareEntity({
    entity: "channelDefVersions",
    graphQL: "ChannelDefVersion",
    name: "Channel Definition Version",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    defaultOrder: [['createdAt', 'DESC']],
    optimizeReading: true,
    fields: (types) => { return {
        id: {
            name: "Channel Definition Version ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            isPublic: true,
            required: true,
            userEditable: false,
        },
        channelDef: {
            name: "Channel Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            hiddenCreate: true,
        },
        inChangeLog: {
            name: "In Change Log",
            type: "enum",
            defaultValue: "-",
            filterable: true,
            values: {
                "-": {
                    name: "Not decided yet",
                },
                "yes": {
                    name: "Yes",
                },
                "no": {
                    name: "No",
                },
            },
        },
        upgradeStatus: {
            name: "Upgrade Status",
            type: "enum",
            filterable: true,
            defaultValue: "auto",
            values: {
                "auto": {
                    name: "Auto upgrade",
                },
                "critical-auto": {
                    name: "Forced auto upgrade (contains critical fix)",
                },
                "no-auto": {
                    name: "No auto upgrade",
                },
                "no-manual": {
                    name: "Upgrade not recommended (may contain a bug)",
                },
                "has-bug": {
                    name: "Do not upgrade (contains bug)",
                },
            },
        },
        changeType: {
            name: "Change Type",
            type: "enum",
            values: {
                "feature": {
                    name: "Feature",
                },
                "improvement": {
                    name: "Improvement",
                },
                "bug": {
                    name: "Bug fix",
                },
                "critical-bug": {
                    name: "Critical bug fix",
                },
                "other": {
                    name: "Other",
                },
            },
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        isPublished: {
            name: "Is published",
            type: "boolean",
            defaultValue: false,
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        title: {
            name: "Change Title",
            type: "string",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        description: {
            name: "Change Description",
            type: "text",
            defaultValue: "",
        },
        commitDescription: {
            name: "Commit Description",
            type: "text",
            defaultValue: "",
        },
        marketingImpact: {
            name: "Marketing Impact",
            type: "string",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        partnersImpact: {
            name: "Partners Impact",
            type: "string",
            defaultValue: "",
            visibility: (data) => { return data['inChangeLog'] === 'yes'; },
        },
        gitTag: {
            name: "Git sha",
            type: "string",
        },
        gitAuthorName: {
            name: "Git Author Name",
            type: "string",
        },
        gitAuthorEmail: {
            name: "Git Author e-mail",
            type: "string",
        },
        groupDefsContent: {
            name: "Group Definition Content",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            import: false,
            offload: true,
            userEditable: false,
        },
        channelDefContent: {
            name: "Application Definition Content",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            import: false,
            offload: true,
            userEditable: false,
        },
        channelDefContentGit: {
            name: "Application Definition Content (GIT)",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            import: false,
            offload: true,
            userEditable: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        ticketUrl: {
            name: "Ticket URL",
            type: "url",
            defaultValue: "",
        },
        changeAuthor: {
            name: "Last change author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
